let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5lkC8")).then(() => parcelRequire('eVoO9'));